import { useRemoteConfig as useBaseRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config'

import type { RemoteConfig } from 'src/constants/remote-config';

export const useRemoteConfig = () => useBaseRemoteConfig<RemoteConfig>();